import { shuffle } from "./utils.js";

/*
u* Rotates the board by _deg_ degrees
 */
function rotateBoard(deg, { board }) {
  //TODO: check translate
  board.style.transform = `translate(15%, 20%) rotate(${deg}deg)`;
}

/* 
 * Toggles a class that hides the cursor and changes buttons to not show a pointer on hover
 */
function hideCursors({ board }) {
  board.classList.add("cursorless");
  document.body.classList.add("cursorless");
}

function unhideCursors({ board }) {
  board.classList.remove("cursorless");
  document.body.classList.remove("cursorless");
}

/* 
 * Positions the buttons randomly 
 */
function scatterButtons_old({ buttons, board }) {
  setPositionAbsolute({ buttons });
  const padding = 16;
  const { width: buttonWidth, height: buttonHeight } = buttons[0].getBoundingClientRect();
  positions = {};
  buttons.forEach((button) => {
    let placed = false;
    let top = Math.random() * (window.innerHeight - padding - buttonHeight - board.getBoundingClientRect().top);
    let left = Math.random() * (window.innerWidth - padding - buttonWidth);
    while (!placed) {
      for ([key, position] in positions) {
        if (
          // Check if new top doesn't overlap i.e. it's top edge is above the bottom, and it's bottom edge is bleow the top of the other
          (top <= position.top + buttonHeight && top + buttonHeight >= position.top) ||
          (left <= position.left + buttonWidth && left + buttonWidth >= position.left)
        ) {
          top = Math.random() * (window.innerHeight - padding - buttonHeight - board.getBoundingClientRect().top);
          left = Math.random() * (window.innerWidth - padding - buttonWidth);
        }
      }
    }
    button.style.top = `${Math.random() * (window.innerHeight - padding - buttonHeight - board.getBoundingClientRect().top)}px`;
    button.style.left = `${Math.random() * (window.innerWidth - padding - buttonWidth)}px`;
  });
}

function scatterButtons_old03({ buttons, board }) {
  setPositionAbsolute({ buttons });
  const padding = 16;
  const { width: buttonWidth, height: buttonHeight } = buttons[0].getBoundingClientRect();
  const boardRect = board.getBoundingClientRect();

  const numCols = Math.floor((window.innerWidth - (padding * 2) - (buttonWidth)) / buttonWidth);
  const numRows = Math.floor((window.innerHeight - (padding * 2) - boardRect.top - buttonHeight) / buttonHeight);

  const validPositions = [];

  for (let i = 0; i < numCols; i++) {
    for (let j = 0; j < numRows; j++) {
      validPositions.push({
        top: j * (buttonHeight + padding),
        left: i * (buttonWidth + padding)
      });
    }
  }

  shuffle(validPositions);
  // TODO: Convert to use transfrom instead of top and left
  buttons.forEach((button, i) => {
    button.style.top = `${validPositions[i].top}px`;
    button.style.left = `${validPositions[i].left}px`;
  });
}

function scatterButtons({ buttons, board }) {
  // console.log("scattering buttons");
  const { width: buttonWidth, height: buttonHeight } = buttons[0].getBoundingClientRect();
  const EDGES = {
    left: 0,
    right: window.innerWidth - buttonWidth,
    top: board.getBoundingClientRect().top,
    bottom: window.innerHeight - buttonHeight,
  }
  const BUTTON_WIDTH = buttons[0].getBoundingClientRect().width;
  const BUTTON_HEIGHT = buttons[0].getBoundingClientRect().height;

  /* Takes in two objest with properties left, right, top, and bottom, 
   * and returns a boolean inidicating if they overlap
  */
  function isOverlapping(a, b) {
    return (
      //a.left < b.right
      a.x < b.x + BUTTON_WIDTH &&
      //a.right > b.left
      a.x + BUTTON_WIDTH > b.x &&
      //a.top < b.bottom
      a.y < b.y + BUTTON_HEIGHT &&
      //a.bottom > b.top
      a.y + BUTTON_HEIGHT > b.y
    )
  }

  const MAX_ATTEMPTS = 100;
  const placedButtons = [];


  buttons.forEach((button) => {
    let placed = false;
    let attempts = 0;
    let possible = {};
    while (!placed && attempts < MAX_ATTEMPTS) {
      possible.x = Math.random() * EDGES.right;
      possible.y = Math.random() * (EDGES.bottom - EDGES.top);

      let collision = false;
      for (let i = 0; i < placedButtons.length; i++) {
        if (isOverlapping(placedButtons[i], possible)) {
          collision = true;
          break;
        }
      }

      if (!collision) {
        placedButtons.push(possible);
        button.style.transfrom = `translate(0,0)`;
        button.style.transform = `translate(${possible.x - button.offsetLeft}px, ${possible.y - button.offsetTop}px)`
        placed = true;
      }
      attempts++;
    }
  })
}


/*
 * Position buttons along edge of the browser using grid
 * */
function gridEdgeScatter({ board }) {
  board.classList.add('scatter');
}

function edgeScatter({ board, buttons }) {
  const totalWidth = window.innerWidth;
  const totalHeight = window.innerHeight;
  const buttonRect = buttons[0].getBoundingClientRect();
  const boardRect = board.getBoundingClientRect();


  const minPadding = 32;
  const buttonsPerRow = Math.min(4, Math.floor((totalWidth + minPadding) / (buttonRect.width + minPadding)));

  // const vPadding = totalHeight / (buttons.length / buttonPerRow);
  const numberRows = buttons.length / buttonsPerRow;
  const totalUsedSpace = numberRows * buttonRect.height;
  const remainingSpace = totalHeight - totalUsedSpace;
  const vPadding = remainingSpace / (numberRows - 1);
  // const vPadding = (totalHeight - (numberRows * buttonRect.height)) / (numberRows - 1);

  // const hPadding = (totalWidth - (buttonsPerRow * buttonRect.width)) / (buttonsPerRow - 1);
  const totalHUsedSpace = buttonsPerRow * buttonRect.width;
  const remainHSpace = totalWidth - totalHUsedSpace;
  const hPadding = remainHSpace / (buttonsPerRow - 1);

  buttons.forEach((button, i) => {
    button.classList.add("absolute");
    if (i < buttonsPerRow) {
      button.style.top = `${Math.floor(i / buttonsPerRow) * buttonRect.height - boardRect.top}px`
    }

    else {
      button.style.top = `${Math.floor(i / buttonsPerRow) * (buttonRect.height + vPadding) - boardRect.top}px`
      // button.style.top = `${(i / buttonsPerRow) * buttonRect.height + vPadding - boardRect.top}px`
    }
    if (i % buttonsPerRow > 0) {
      button.style.left = `${(i % buttonsPerRow) * (buttonRect.width + hPadding)}px`
    }
    else {
      button.style.left = `${(i % buttonsPerRow) * buttonRect.width}px`
    }
  });



}

/* 
 * Positions the buttons along the edge of the browser window
 */
function edgeScatter_old({ board }) {
  const totalWidth = window.innerWidth;
  const totalHeight = window.innerHeight;
  const rowButtonCount = document.querySelector('.row').childElementCount;
  const boardRect = board.getBoundingClientRect();
  let rowHeights = [];
  const hPadding = 32;
  board.style.transform = `translate(0%, 0%)`;
  document.querySelectorAll('.row').forEach((row) => {
    let rowButtonWidths = 0;
    let maxRowHeight = 0;

    // Distribute the buttons horizontally
    row.querySelectorAll('button').forEach((btn, i) => {
      rowButtonWidths += btn.getBoundingClientRect().width;
      if (btn.getBoundingClientRect().height > maxRowHeight) {
        maxRowHeight = btn.getBoundingClientRect().height;
      }
    });
    const spaceAvailable = totalWidth - rowButtonWidths - hPadding;
    const spaceBetween = spaceAvailable / (rowButtonCount - 1)
    let currentX = 0;
    row.querySelectorAll('button').forEach((btn) => {
      btn.classList.add('absolute');
      btn.style.left = `${currentX}px`;
      currentX += (spaceBetween + btn.getBoundingClientRect().width);
    });
    rowHeights.push(maxRowHeight);
  });

  // Distribute the buttons vertically
  const totalRowHeight = rowHeights.reduce((sum, value) => sum + value);
  const vPadding = 32;
  const vSpaceAvilable = totalHeight - totalRowHeight - vPadding;
  const vSpaceBetween = vSpaceAvilable / (document.querySelectorAll('.row').length - 1);
  //Offset by the y position of the board 
  let currentY = -1 * boardRect.top;
  document.querySelectorAll('.row').forEach((row, i) => {
    row.querySelectorAll('button').forEach((btn) => {
      btn.style.top = `${currentY}px`;
    });
    currentY += (vSpaceBetween + rowHeights[i]);
  });
}


/*
 * Sets the position value for all buttons to absolute 
 * And adds in a transition style
 * */
function setPositionAbsolute({ buttons }) {
  let buttonArray = Array.from(buttons);
  buttonArray.forEach((btn) => {
    btn.style.position = 'absolute';
    btn.style.transition = 'top 1000ms, left 1000ms';
  });
}


/*
 * Set buttons to their initial positions  
 */
function resetToInitialPosition({ buttons, initialPositions }) {
  document.querySelector(".board").style.transition = '';
  buttons.forEach((button) => {
    const { left, top } = initialPositions[button.id];
    button.style.position = '';
    button.style.left = left;
    button.style.top = top;
    button.style.transform = '';
  });
}

/*
 * Shuffles the position of all the buttons
 * */
function buttonShuffle_old({ board, buttons, initialPositions }) {
  resetToInitialPosition({ board, buttons, initialPositions });
  const boardRect = board.getBoundingClientRect();
  // Reassign buttons to account for missing button
  buttons = document.querySelectorAll(".board button");
  let buttonArray = Array.from(buttons);
  let buttonsPositions = buttonArray.map((btn) => {
    const btnRect = btn.getBoundingClientRect();
    return { x: btnRect.x, y: btnRect.y };
  });

  board.classList.remove("poof");

  setPositionAbsolute({ buttons });

  buttonArray.forEach((btn, i) => {
    btn.style.left = `${buttonsPositions[i].x}px`;
    btn.style.top = `${buttonsPositions[i].y - boardRect.top}px`;
    btn.addEventListener('transitionend', () => {
      btn.style.transition = 'top 1000ms, left 1000ms';
    });
  })

  //shuffle the positions
  for (let i = buttonsPositions.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [buttonsPositions[i], buttonsPositions[j]] = [buttonsPositions[j], buttonsPositions[i]];
  }

  setTimeout(() => {
    buttonArray.forEach((btn, i) => {
      btn.style.left = `${buttonsPositions[i].x}px`;
      btn.style.top = `${buttonsPositions[i].y - boardRect.top}px`;
    });
  }, 0)
}

function buttonShuffle_old2({ board, buttons, initialPositions }) {
  resetToInitialPosition({ board, buttons, initialPositions });

  buttons = document.querySelectorAll(".board button");
  let buttonRect = buttons[0].getBoundingClientRect();

  // let indexList = shuffle(Array(buttons.length).keys());
  let indexList = Array.from(Array(buttons.length).keys());
  shuffle(indexList);

  board = document.querySelector(".board");
  setTimeout(() => {
    buttons.forEach((button, i) => {
      button.style.transition = `transform 1000ms ease`;
      let currentRow = Math.floor(i / (window.innerWidth > 640 ? 4 : 3));
      // let currentRow = i % (window.innerWidth > 640 ? 4 : 3); // 4 buttons per row
      let currentColumn = i % (window.innerWidth > 640 ? 4 : 3);
      let newRow = Math.floor(indexList[i] / (window.innerWidth > 640 ? 4 : 3));
      let newColumn = indexList[i] % (window.innerWidth > 640 ? 4 : 3);
      let padding = parseFloat(getComputedStyle(board).gap);
      let deltaY = (newRow - currentRow) * (buttonRect.height + padding);
      let deltaX = (newColumn - currentColumn) * (buttonRect.width + padding);


      button.style.transform = `translate(${deltaX}px, ${deltaY}px)`
      setTimeout(() => button.style.transition = "", 1000);
    });
  }, 2000);
  // buttons.forEach((button, i) => {
  //   button.style.transition = `order 1500ms ease`;
  // });
  //
  // buttons.forEach((button, i) => {
  //   setTimeout(() => { button.style.order = indexList[i]; }, 200 * i);
  // });

}

function buttonShuffle({ board, buttons, initialPositions }) {
  resetToInitialPosition({ board, buttons, initialPositions });

  buttons = document.querySelectorAll(".board button");
  if (!buttons) {
    console.error("Button array is null");
    return;
  }
  buttons = Array.from(buttons).filter((button) => button.checkVisibility());
  // let buttonRect = buttons[0].getBoundingClientRect();

  // let indexList = shuffle(Array(buttons.length).keys());
  let indexList = Array.from(Array(buttons.length).keys());
  shuffle(indexList);

  board = document.querySelector(".board");

  const startingPositions = Array.from(buttons).reduce((acc, button) => {
    acc[button.id] = button.getBoundingClientRect();
    return acc;
  }, {});

  buttons.forEach((button, i) => {
    button.style.transition = `transform 1000ms ease`;

    let swapId = buttons[indexList[i]].id;
    // Difference from new positions (the swap-to buton) and the current position
    let deltaY = startingPositions[swapId].top - startingPositions[button.id].top;
    let deltaX = startingPositions[swapId].left - startingPositions[button.id].left;


    button.style.transform = `translate(${deltaX}px, ${deltaY}px)`
    setTimeout(() => button.style.transition = "", 1000);
  });
  // buttons.forEach((button, i) => {
  //   button.style.transition = `order 1500ms ease`;
  // });
  //
  // buttons.forEach((button, i) => {
  //   setTimeout(() => { button.style.order = indexList[i]; }, 200 * i);
  // });

}


export { edgeScatter, gridEdgeScatter, rotateBoard, hideCursors, unhideCursors, buttonShuffle, scatterButtons, resetToInitialPosition }
